/* v3.1 2026-10-01 - re-committed: this asset was missing from the GitHub branch (initial theme->git sync skipped it), so merges never carried it to the live theme. No functional changes. */
/* v3.2 2026-10-08 - Ships-every snaps to the selected tier's recommended cadence: explicit data-freq (tierX_freq/kit_freq block settings) wins, else the first number in the tier title, clamped to the plans that exist; Buy N Get M titles count N+M units. The "(recommended)" suffix follows the snapped option. */
/* v3.3 2026-10-16 - CROSS-PRODUCT KIT: when the kit radio carries data-foreign-id (kit_product block setting resolved the kit SKU on another product), product-form.js finds no option match and clears select[name=id] + disables the CTA. foreignFix() (form-level change listener registered AFTER product-form's, plus one call on init) restores the select to the foreign variant id and re-enables the CTA. render() swaps [name=selling_plan] to the foreign product's plan id for the selected cadence (data-plan-1/2/3; never a page-product plan id, which the Cart API would reject for a foreign variant) and hides the dynamic payment button while a foreign kit is selected. */
(function () {
  /**
   * Buy Box V3 (Kit Ladder)
   *
   * Owns: Subscribe/One-time mode toggle, frequency select, dynamic CTA and
   * disclosure copy, free-shipping meter, sticky-bar price sync, and the
   * kit's add-on line. product-form.js still owns the primary add-to-cart
   * (it AJAX-adds the refill/selected variant with the selling plan); when
   * the kit tier is selected this script additionally posts the add-on
   * variant as a ONE-TIME line, so renewals ship refills only.
   *
   * A11y: the mode toggle is a group of toggle buttons (aria-pressed), NOT
   * tabs - tab semantics were flagged in the 2026-09 ADA audit as the wrong
   * role for option pickers.
   */
  function money(cents) {
    var d = cents / 100;
    return '$' + (cents % 100 === 0 ? d : d.toFixed(2));
  }

  function init() {
    var box = document.querySelector('.bbv3');
    if (!box) return;
    var form = box.querySelector('form');
    if (!form) return;
    var modeBtns = box.querySelectorAll('[data-bbv3-mode]');
    var radios = box.querySelectorAll('.bbv3-input');
    var freqSel = box.querySelector('.bbv3-freq-select');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var variantSelect = form.querySelector('select[name="id"]');
    var payBtn = box.querySelector('.bbv3-paybtn');
    var cta = box.querySelector('[data-bbv3-cta]');
    var disc = box.querySelector('[data-bbv3-disc]');
    var ship = box.querySelector('.bbv3-ship');
    var shipText = ship ? ship.querySelector('[data-bbv3-ship-text]') : null;
    var shipFill = ship ? ship.querySelector('[data-bbv3-ship-fill]') : null;
    var renewEls = box.querySelectorAll('[data-bbv3-freqtext]');
    var bar = document.querySelector('.atc-bar-v2');
    var barPrice = bar ? bar.querySelector('[data-atc-price]') : null;
    var barInst = bar ? bar.querySelector('[data-atc-installment]') : null;
    var mode = box.classList.contains('bbv3--sub') ? 'sub' : 'one';
    var cartTotal = 0;

    function selected() {
      return box.querySelector('.bbv3-input:checked');
    }
    function freqLabel() {
      if (!freqSel) return '';
      var o = freqSel.options[freqSel.selectedIndex];
      return o ? o.getAttribute('data-label') || '' : '';
    }

    // Recommended cadence (months) for a tier: explicit data-freq from the
    // block settings wins; otherwise the FIRST number in the rendered tier
    // title ("3 Pack" -> 3). No number = '' (no snap).
    function recMonths(r) {
      if (!r) return '';
      var explicit = r.getAttribute('data-freq');
      if (explicit) return explicit;
      var title = box.querySelector('label[for="' + r.id + '"] .bbv3-title');
      if (!title) return '';
      var t = title.textContent;
      var bogo = t.match(/buy\s*(\d+)[,\s]*get\s*(\d+)/i);
      if (bogo) return String(parseInt(bogo[1], 10) + parseInt(bogo[2], 10));
      var m = t.match(/\d+/);
      return m ? m[0] : '';
    }

    // Snap the Ships-every select to the selected tier's recommended
    // cadence, clamped to the plans that actually exist ("21" never
    // matches, so strips with treatment counts are left alone). Moves the
    // "(recommended)" suffix onto the snapped option.
    function snapFreq() {
      if (!freqSel) return;
      var n = recMonths(selected());
      if (!n) return;
      var target = null;
      for (var i = 0; i < freqSel.options.length; i++) {
        var o = freqSel.options[i];
        var lab = (o.getAttribute('data-label') || '').match(/^(\d+)\s*month/);
        if (lab && lab[1] === n) { target = o; break; }
      }
      if (!target) return;
      freqSel.value = target.value;
      for (var j = 0; j < freqSel.options.length; j++) {
        var oo = freqSel.options[j];
        var base = oo.getAttribute('data-label') || oo.textContent;
        oo.textContent = oo === target ? base + ' (recommended)' : base;
      }
    }

    function render() {
      box.classList.toggle('bbv3--sub', mode === 'sub');
      box.classList.toggle('bbv3--one', mode === 'one');
      modeBtns.forEach(function (b) {
        var on = b.getAttribute('data-bbv3-mode') === mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (freqSel) freqSel.disabled = mode !== 'sub';
      var r = selected();
      if (planInput) {
        var pv = '';
        if (mode === 'sub' && freqSel) {
          pv = freqSel.value;
          if (r && r.getAttribute('data-foreign-id')) {
            // Foreign kit: the freq select holds the PAGE product's plan ids.
            // Map the chosen cadence to the kit product's own plan id - a
            // page plan id on a foreign variant is rejected by the Cart API.
            var fo = freqSel.options[freqSel.selectedIndex];
            var fm = ((fo && fo.getAttribute('data-label')) || '').match(/^(\d+)/);
            var fn = fm ? fm[1] : '1';
            pv = r.getAttribute('data-plan-' + fn) || r.getAttribute('data-plan-3') || r.getAttribute('data-plan-2') || r.getAttribute('data-plan-1') || '';
          }
        }
        planInput.value = pv;
        planInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (payBtn) payBtn.style.display = r && r.getAttribute('data-foreign-id') ? 'none' : '';
      if (!r) return;
      var isKit = r.hasAttribute('data-kit');
      var price = parseInt(mode === 'sub' ? r.getAttribute('data-sub') : r.getAttribute('data-one'), 10) || 0;

      if (cta) {
        var label = mode === 'sub'
          ? (isKit ? cta.getAttribute('data-label-kit') : cta.getAttribute('data-label-sub'))
          : cta.getAttribute('data-label-one');
        cta.textContent = label + ' · ' + money(price);
      }

      renewEls.forEach(function (el) {
        el.textContent = 'every ' + freqLabel();
      });

      if (disc) {
        var tpl = mode === 'sub'
          ? (isKit ? disc.getAttribute('data-sub-kit') : disc.getAttribute('data-sub'))
          : disc.getAttribute('data-one');
        var renew = parseInt(r.getAttribute('data-renew') || r.getAttribute('data-sub'), 10) || price;
        disc.textContent = (tpl || '')
          .replace('{freq}', 'every ' + freqLabel())
          .replace('{price}', money(renew));
      }

      if (ship && shipText && shipFill) {
        var th = parseInt(ship.dataset.threshold, 10) || 0;
        if (mode === 'sub') {
          ship.classList.remove('bbv3-ship--pending');
          shipText.textContent = ship.dataset.subMsg;
          shipFill.style.width = '100%';
        } else if (th > 0) {
          var subtotal = cartTotal + price;
          var rem = th - subtotal;
          if (rem <= 0) {
            ship.classList.remove('bbv3-ship--pending');
            shipText.textContent = ship.dataset.over;
            shipFill.style.width = '100%';
          } else {
            ship.classList.add('bbv3-ship--pending');
            shipText.textContent = ship.dataset.under.replace('{amt}', money(rem));
            shipFill.style.width = Math.round((subtotal / th) * 100) + '%';
          }
        }
      }

      if (barPrice) barPrice.textContent = '- ' + money(price);
      if (barInst) barInst.textContent = '$' + (price / 400).toFixed(2);
    }

    // Foreign kit fixup. product-form.js can't option-match a foreign
    // variant, so on every option change it clears select[name=id] and
    // disables the CTA. This listener is registered AFTER product-form's
    // (script order: product-form.js loads first), so it runs last on the
    // bubble and restores the foreign state. Harmless no-op otherwise.
    function foreignFix() {
      var r = selected();
      if (!r) return;
      var fid = r.getAttribute('data-foreign-id');
      if (!fid) return;
      if (variantSelect) {
        variantSelect.value = fid;
        if (variantSelect.value !== fid) {
          // No matching <option> (markup must emit one for the foreign id) -
          // leave product-form's disabled state alone rather than add a
          // broken line to the cart.
          return;
        }
      }
      if (cta && !r.disabled) {
        cta.disabled = false;
      }
    }
    form.addEventListener('change', foreignFix);

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        mode = b.getAttribute('data-bbv3-mode');
        render();
      });
    });
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        snapFreq();
        render();
      });
    });
    if (freqSel) freqSel.addEventListener('change', render);

    // Kit selected: also add the add-on variant as a one-time line.
    // product-form.js prevents the default submit and AJAX-adds the refill
    // line (with the selling plan); this posts the add-on beside it, then
    // refreshes the cart UI again so the panel shows both lines.
    form.addEventListener('submit', function () {
      var r = selected();
      if (!r || !r.hasAttribute('data-kit')) return;
      var addonId = parseInt(r.getAttribute('data-addon-id'), 10);
      if (!addonId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addonId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('addon add failed');
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:count:updated', {
            detail: { count: cart.item_count, total: cart.total_price }
          }));
          document.dispatchEvent(new CustomEvent('cart:item:added'));
        })
        .catch(function () {
          if (disc) disc.textContent = 'The LED could not be added - please try again or add it from the cart.';
        });
    });

    document.addEventListener('cart:count:updated', function (e) {
      if (e.detail && typeof e.detail.total === 'number') {
        cartTotal = e.detail.total;
        render();
      }
    });

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price; render(); })
      .catch(render);

    snapFreq();
    render();
    foreignFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();